import React from 'react';
import ReactDOM from 'react-dom';
import RedshelfApolloClient from '@redshelf/redshelf-data';
import { AppProvider } from '@redshelf/redshelf-ui';

import { APOLLO_CACHE_CONFIG } from 'constants';
import routes from './routes';

const environment = process.env.REACT_APP_NODE_ENV || process.env.NODE_ENV;

ReactDOM.render(
  <React.StrictMode>
    <RedshelfApolloClient
      environment={environment}
      clientSideFields={APOLLO_CACHE_CONFIG.typePolicies.Query.fields}
    >
      <AppProvider
        RouterProps={{ routes }}
        ToastProviderProps={{
          maxStack: 10,
          domRoot: document.body,
        }}
      />
    </RedshelfApolloClient>
  </React.StrictMode>,
  document.getElementById('root'),
);
